import { deviceApi } from './services/device';
import { configureStore } from '@reduxjs/toolkit';
import { loginMiddleware } from './middleware/login-middleware';
import { newPortalUserDataMiddleware } from './middleware/new-portal-user-data-middleware';
import { authenticationSlice } from './features/authentication';
import { uiSlice } from './features/ui';
import { planningSlice } from './features/planning';
import { useDispatch } from 'react-redux';
import { formSlice } from './features/form';
import { globalSearchSlice } from './features/globalSearch';
import { viewAsSupplierSlice } from './features/viewAsSupplier';
// import { errorHandlerMiddleware } from './middleware/error-logging-middleware';

export const store = configureStore({
    reducer: {
        authentication: authenticationSlice.reducer,
        ui: uiSlice.reducer,
        planning: planningSlice.reducer,
        form: formSlice.reducer,
        globalSearch: globalSearchSlice.reducer,
        viewAsSupplier: viewAsSupplierSlice.reducer,
        [deviceApi.reducerPath]: deviceApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false })
            .prepend(loginMiddleware.middleware)
            .prepend(newPortalUserDataMiddleware.middleware)
            .concat(deviceApi.middleware),
    // .concat(errorHandlerMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch<AppDispatch>;
